module.exports = __webpack_public_path__ + "static/media/Pan Tostado a la Parrilla con Guacamole.4c3d401c.webp";